import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Popup from "@/ts/Popup/Popup";
import {computed, ref, watch, watchEffect} from "vue";

type Theme = 'light' | 'dark';


export default /*@__PURE__*/_defineComponent({
  __name: 'Popup',
  props: /*@__PURE__*/_mergeModels({
  maxHeight: {
    type: Number,
    required: false,
  },
  theme: {
    type: String as () => Theme,
    default: 'light'
  }
}, {
    "show": {},
    "showModifiers": {},
  }),
  emits: ["update:show"],
  setup(__props) {


const props = __props;
const popupStyle = ref({})
const container = ref<HTMLElement>()
const show = _useModel(__props, 'show')
const closing = ref(false)
const popup = new Popup(100, 80, popupStyle)
const close = () => {
  show.value = false;
}
popup.onClose(close)
watch(() => show.value, (newValue: boolean, oldValue) => {
  if (newValue) {
    if (container.value) {
      popup.init(container.value)
    }
  } else {
    closing.value = true

    setTimeout(() => {
      closing.value = false
    }, 600)

    popup.destroy()
  }
}, )
const maxPopupHeight = computed(() => {
  return props.maxHeight ? `${props.maxHeight}px` : `calc(100% - 54px)`;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup-container", {show: show.value, closing: closing.value}]),
    style: _normalizeStyle({'--max-height': maxPopupHeight.value})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["popup", {show: show.value, [__props.theme]: true}]),
      ref_key: "container",
      ref: container,
      style: {}
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("div", {
      class: "popup-overlay",
      onClick: close
    })
  ], 6))
}
}

})